import Vue from 'vue'
import VueRouter from 'vue-router'
import { setAsyncRoutes } from './async'
import Layout from '../components/layout/layout.vue'
import Login from '../views/login/login.vue'

Vue.use(VueRouter)

export const defaultRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/allActive',
    children: [
      // 学校活跃数据
      {
        path: '/allActive',
        name: 'AllActive',
        component: () => import('../views/schActiveData/allActiveSch.vue'),
        meta: { title: '整体活跃' }
      },
      {
        path: '/allActive/allActiveTecDetail',
        name: 'AllActiveTecDetail',
        component: () =>
          import('../views/schActiveData/allActiveTecDetail.vue'),
        meta: { title: '整体活跃/教师明细' }
      },
      {
        path: '/allActive/allActiveGradeSubAct',
        name: 'AllActiveGradeSubAct',
        component: () =>
          import('../views/schActiveData/allActiveGradeSubAct.vue'),
        meta: { title: '整体活跃/年级学科活跃' }
      },
      {
        path: '/allActive/allActiveGradeSubDetail',
        name: 'AllActiveGradeSubDetail',
        component: () =>
          import('../views/schActiveData/allActiveGradeSubDetail.vue'),
        meta: { title: '整体活跃/年级学科活跃/教师明细' }
      },
      {
        path: '/homeworkAnalysis',
        name: 'HomeworkAnalysis',
        component: () => import('../views/schActiveData/homeworkAnalysis.vue'),
        meta: { title: '作业分析' }
      },
      {
        path: '/homeworkAnalysis/homeworkTecDetail',
        name: 'HomeworkTecDetail',
        component: () => import('../views/schActiveData/homeworkTecDetail.vue'),
        meta: { title: '作业分析/教师明细' }
      },
      {
        path: '/couserwareAnalysis',
        name: 'CouserwareAnalysis',
        component: () =>
          import('../views/schActiveData/couserwareAnalysis.vue'),
        meta: { title: '课件分析' }
      },
      {
        path: '/workMonitor',
        name: 'WorkMonitor',
        component: () => import('@/views/schActiveData/workMonitor.vue'),
        meta: { title: '作业监测' }
      },
      {
        path: '/couserwareAnalysis/couserwareTecDeatil',
        name: 'CouserwareTecDeatil',
        component: () =>
          import('../views/schActiveData/couserwareTecDeatil.vue'),
        meta: { title: '课件分析/教师明细' }
      },
      // 题库使用数据
      {
        path: '/regionalQuestion',
        name: 'RegionalQuestion',
        component: () => import('../views/questionData/regionalQuestion.vue'),
        meta: { title: '区域题库分析' }
      },
      {
        path: '/regionalQuestion/questionAnalysis',
        name: 'QuestionAnalysis',
        component: () => import('../views/questionData/questionAnalysis.vue'),
        meta: { title: '区域题库分析/题库分析' }
      },
      {
        path: '/schoolQuestion',
        name: 'SchoolQuestion',
        component: () => import('../views/questionData/schoolQuestion.vue'),
        meta: { title: '学校题库分析' }
      }
    ]
  },
  {
    path: '*', // 错误路由
    component: () => import('@/views/error/404.vue')
  }
]

const router = new VueRouter({
  routes: [...defaultRoutes]
})
//增加下面代码解决重读点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 路由导航守卫,刷新时候获取浏览器内存数据
router.beforeEach((to, from, next) => {
  // 当路由没被配置的时候，meta 中的 require 字段为 undefined
  // if(!to.meta.require && to.path !== '/login') {
  //   // 从 session 中获取菜单
  //   const menu = JSON.parse(sessionStorage.getItem('menu'));
  //   // 重新配置路由
  //   setAsyncRoutes(menu);
  //   router.replace(to.path);
  // } else next();
  let userInfo = sessionStorage.getItem('userInfo')
  if (userInfo === null && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
})

export default router
